<template>
  <div class="mb-3 ">
    <callout has-toggle>
      <div class="row py-2">
        <div class="col-md col-12">
          <div class="row">
            <div class="col-md col-12">
              <div class="data-label">
                Aplicación:
              </div>
              {{ data.app?.name | empty }}
            </div>
            <div class="col-md col-12">
              <div class="data-label">
                Última Fecha de Modificación:
              </div>
              {{ data.updatedDate | dateTime }}
            </div>
            <div class="w-100 border m-3"></div>
            <div class="col-md col-12">
              <div class="data-label">
                Rol(es):
              </div>
              {{ data.roles | chain('name') }}
            </div>
          </div>
        </div>
        <div
          class="col-md-2 col-12 d-flex align-items-center justify-content-center"
        >
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger"
            class="mr-2"
            @click="remove"
          />

          <action-button i="fas fa-edit" variant="success" @click="edit" />
        </div>
      </div>

      <template #edition>
        <div class="bg-gray p-2">
          <div class="bg-white rounded p-3">
            <div class="d-flex">
              <i class="fas fa-info-circle text-orange mr-2 mt-1"></i>
              <p class="font-weight-normal font-16">
                Información Adicional
              </p>
            </div>
            <div class="data-label">
              Reorganización de Tipo de Publicación:
            </div>
            <div class="d-flex flex-wrap">
              <section-item
                v-for="item in data.sections"
                :key="item.id"
                :data="item"
                read-only
              />
            </div>
          </div>
        </div>
      </template>
    </callout>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import Callout from 'custom-callout';
import SectionItem from '../manage/components/SectionItem.vue';

export default {
  name: 'ResultRow',
  components: { ActionButton, Callout, SectionItem },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  filters: {
    chain(value, prop) {
      return value ? value.map((x) => x[prop]).join(', ') : '-';
    },
  },
  methods: {
    remove() {
      this.$emit('remove', this.data.id);
    },
    edit() {
      this.$emit('edit', this.data.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
</style>
